var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Caption, Row, Col } from "./";
import Text from "./Text";
import React from 'react';
import { styled } from "../utils";
var StyledText = styled(Text)(function (_a) {
    var _b = _a.clickable, clickable = _b === void 0 ? false : _b;
    return (__assign({}, (clickable
        ? {
            cursor: 'pointer',
            '&:hover': {
                textDecoration: 'underline',
            },
        }
        : {})));
});
var PriceRow = function (_a) {
    var value = _a.value, label = _a.label, caption = _a.caption, _b = _a.large, large = _b === void 0 ? false : _b, className = _a.className, _c = _a.quantity, quantity = _c === void 0 ? 1 : _c, priceRef = _a.priceRef, onClick = _a.onClick, spaceProps = __rest(_a, ["value", "label", "caption", "large", "className", "quantity", "priceRef", "onClick"]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, __assign({}, spaceProps, { className: className, justifyContent: "space-between", alignItems: "flex-end", ref: priceRef, onClick: onClick }),
            React.createElement(Col, { width: 6 / 10, px: 0 },
                React.createElement(StyledText, { fontFamily: large ? 'tertiary' : 'primary', fontWeight: large ? 'bold' : 'medium', fontSize: large ? ['normal', 'extraLarge'] : ['small', 'large'], letterSpacing: large ? [1.13, 1.81] : [0.7, 0.96], clickable: !!onClick }, label)),
            quantity > 1 ? (React.createElement(Col, { px: 0, ml: '0.5rem' },
                React.createElement(Text, { pl: [3, 6], fontFamily: 'primary', fontWeight: "bold", fontSize: large ? ['normal', 'extraLarge'] : ['small', 'large'], letterSpacing: "-1.3px" },
                    "x",
                    quantity))) : null,
            React.createElement(Col, { px: 0, width: 3 / 10, textAlign: 'right' },
                React.createElement(Text, { pl: [3, 6], fontFamily: "tertiary", fontSize: large ? ['normal', 'extraLarge'] : ['small', 'large'], fontWeight: "bold", letterSpacing: large ? [1.13, 1.81] : [0.87, 1.2], whiteSpace: "nowrap" }, value))),
        caption && (React.createElement(Caption, { fontSize: ['extraTiny', 'tiny'], fontWeight: "normal" }, caption))));
};
export default PriceRow;
//# sourceMappingURL=PriceRow.js.map